export default __webpack_public_path__ + "static/media/ravi_teja_alchuri.8700d425.png";